import { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config';
import { useNavigate } from 'react-router-dom';
import { showError, showSuccess } from '../utils/alerts';
import '../styles/pages/CreateCompanyPage.css';

const CreateCompanyPage = ({ token }) => {
  const [form, setForm] = useState({
    name: '',
    rut: '',
    address: '',
    rep_legal: '',
    rut_representante: '',
    comuna: '',
    ciudad: 'Santiago de Chile',
    email: '',
    phone: '',
    tipo_empresa: '',
    clave_sii: ''
  });
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_BASE_URL}/api/company/companies`, form, {
        headers: { Authorization: `Bearer ${token}` }
      });
      showSuccess('Empresa creada exitosamente');
      setMessage('Empresa creada exitosamente');
      navigate('/select-company');
    } catch (error) {
      console.error('Error al crear empresa:', error);

      // Mostrar mensaje específico del servidor
      const errorMessage = error.response?.data?.message || 'Error al crear empresa';

      // Si es error de límite, mostrar mensaje personalizado
      if (error.response?.status === 403) {
        showError('Has alcanzado el límite de empresas. Contacta a ventas para contratar un nuevo plan.');
      } else {
        showError(errorMessage);
      }

      setMessage(errorMessage);
    }
  };
  return (
    <div className="create-company-container">
      <h1>Crear Empresa</h1>
      <form className="create-company-form" onSubmit={handleSubmit}>
        <input name="name" value={form.name} onChange={handleChange} placeholder="Nombre de la Empresa" required />
        <input name="rut" value={form.rut} onChange={handleChange} placeholder="RUT de la Empresa" required />
        <input name="address" value={form.address} onChange={handleChange} placeholder="Dirección" required />
        <input name="comuna" value={form.comuna} onChange={handleChange} placeholder="Comuna" required />
        <input name="ciudad" value={form.ciudad} onChange={handleChange} placeholder="Ciudad" required />
        <input name="rep_legal" value={form.rep_legal} onChange={handleChange} placeholder="Nombre Representante Legal" required />
        <input name="rut_representante" value={form.rut_representante} onChange={handleChange} placeholder="RUT Representante Legal" required />
        <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="Email" required />
        <input name="phone" value={form.phone} onChange={handleChange} placeholder="Teléfono" required />
        <input
          name="clave_sii"
          type="password"
          value={form.clave_sii}
          onChange={handleChange}
          placeholder="Clave SII (para automatizar RCV)"
        />
        <select
          name="tipo_empresa"
          value={form.tipo_empresa}
          onChange={handleChange}
          required>
          <option value="" disabled>Selecciona el tipo de empresa</option>
          <option value="Producto">Producto</option>
          <option value="Servicio">Servicio</option>
        </select>
        <button type="submit">Crear Empresa</button>
      </form>
      <p className="create-company-hint">
        Selecciona en tipo de empresa, la opción <strong>Servicios</strong> si tu empresa solo vende servicios de consultoría como ser contadores, abogados, arquitectos, etc., y selecciona <strong>Productos</strong> si tu empresa vende cualquier tipo de producto.
      </p>
      {message && <p>{message}</p>}
    </div>
  );
};

export default CreateCompanyPage;